import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_PARTNERSHIP_API_URL,
  timeout: 120000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export const setInstanceAuthorization = (value) =>
  (axiosInstance.defaults.headers.common['Authorization'] = value);

export default axiosInstance;
